import React from "react";

function Navbar() {
    return (
        <div className="bg-bgDark py-4">
            <nav>
                <h1 className="text-3xl font-bold text-center text-white">Top Courses</h1>
            </nav>
        </div>
    );
}

export default Navbar;